module.exports = __webpack_public_path__ + "static/background-8c455989173dce66f2e5f0e9b55cc28a.jpg";